import {
  CellContext,
  ColumnDefTemplate,
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import classNames from 'classnames';
import { TanstackTable } from '../../Table/TanstackTable';
import { CompoundDataPoint } from '../CompoundPage.hooks';
import { formatKRW } from '../../../utils/formatKRW';
import styles from './CompoundTable.module.css';

interface CompoundTableProps {
  histories: CompoundDataPoint[];
  className?: string;
}

const columnHelper = createColumnHelper<CompoundDataPoint>();

const formatCurrency: ColumnDefTemplate<CellContext<CompoundDataPoint, number>> = (info) =>
  formatKRW(info.getValue());

const columns = [
  columnHelper.accessor('year', {
    header: '년차',
    cell: (info) => `${info.getValue()}년차`,
  }),
  columnHelper.accessor('principal', {
    header: '원금',
    cell: formatCurrency,
  }),
  columnHelper.accessor('interest', {
    header: '누적 수익',
    cell: formatCurrency,
  }),
  columnHelper.accessor('totalAsset', {
    header: '총액',
    cell: formatCurrency,
  }),
];

function CompoundTable({ histories, className }: CompoundTableProps) {
  const table = useReactTable({
    data: histories,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <TanstackTable className={classNames(styles.root, className)} table={table} />;
}

export default CompoundTable;
